import React, {type ElementConfig} from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import {
    estadosCarga,
    municipiosCarga,
    planesCarga,
    actualizaFlagMarcadores,
    planesSubplanCarga
} from './directorio.act';
import Select, { components } from "react-select";
import {servicios} from "../properties";

const localizaN = require("../img/localizaN.svg");
const localizaG = require("../img/localizaG.svg");
const urlBASE = servicios.directorio.endPoint;
const esCliente = localStorage.getItem("esCliente") ? true: false;

const mapState = (state) => {
    return {
        estados: state.directorio.estados,
        municipios: state.directorio.municipios,
        initialValues: state.directorio.hospitales,
        planes: state.directorio.planes,
        planesSubplanes: state.directorio.planesSubplanes,
        planeslp: state.directorio.planeslp,
        planeslc: state.directorio.planeslc,
        finalizo: state.directorio.finalizo,
        marcadoresFlag: state.directorio.marcadoresFlag,
        polizasCargadas: state.polizas.polizasCargadas
    };
}

const mapDispatch = (dispatch) => {
    return {
        cargaEstados: () => {
            dispatch(estadosCarga())
        },
        cargaMunicipios: (_idEstado) => {
            dispatch(municipiosCarga(_idEstado))
        },
        guardarDatos(oData) {
            dispatch({ "type" : "DIRECTORIO_HOSPITALES_FORM", "hospitales": oData });
        },
        guardaItemSeleccionado: () => {
            dispatch({ "type": "DIRECTORIO_OPCIONAL", "opcional": {}})
        },
        cargaPlanes: () => {
            dispatch(planesCarga());
        },
        cargaPlanesSubplanes: () => {
            dispatch(planesSubplanCarga());
        },
        cambioFinalizo: () => {
            dispatch({ "type": "DIRECTORIO_FINALIZO", "finalizo": false });
        },
        cambiaFlagMarcadores: (_paso) => {
            dispatch(actualizaFlagMarcadores(_paso));
        },
        tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
    }
}

const validate = (campos) => {
    const errors = {};

	if(!campos.estado) {
		errors.estado = 'Campo requerido.';
	}

	if(!campos.municipio) {
		errors.municipio = 'Campo requerido.';
	}

	if(!campos.plan) {
		errors.plan = 'Campo requerido.';
	}

    return errors;
}

const renderSelectField = ({ input, label, type, meta: { touched, error }, children }) => (
    <div>
        <select id="dd" style={{"display":"inline !important"}} {...input}>
            {children}
        </select>
        {touched && (error &&
			<div>
				<div className='msj-error'>
					<p><span>{error}</span></p>
				</div>
			</div>)
		}
    </div>
)

const style1 = {
    control: (base, state) => ({
        ...base,
        border: "0 !important",
        boxShadow: "0 !important",
        "&:hover": {
            border: "0 !important"
        },
        minHeight: "50px !important"
    }),
    placeholder: (defaultStyles) => {
        return {
            ...defaultStyles,
            color: "#183d7d",
            fontWeight: "bold",
            fontSize: "16px",
            marginLeft: "-8px !important",
            top: "75%"
        }
    }
}

const arrow = require("../img/arrow-down.svg");

const DropdownIndicator = (
    props: ElementConfig<typeof components.DropdownIndicator>
) => {
    return (
        <components.DropdownIndicator {...props}>
            <img src={arrow}/>
        </components.DropdownIndicator>
    );
}

const renderSelectR = ({input: {onChange, value}, options, formatGroupLabel, name}) => (
    <div>
        <Select
            id="rs"
            name={name}
            value={value}
            isSearchable={false}
            components={{DropdownIndicator, IndicatorSeparator: () => null}}
            formatGroupLabel={formatGroupLabel}
            formatOptionLabel={formatOptionLabel}
            defaultValue={{label: "Todos", value: "0"}}
            options={options}
            onChange={onChange}
            placeholder="Todos"
            hideSelectedOptions={true}
        styles={style1}/>
    </div>
)

const onChange = (optionSelected) => {
    localStorage.setItem("planValue", optionSelected.value);
}

const groupBadgeStyles = {
    backgroundColor: '#EBECF0',
    borderRadius: '2em',
    color: '#172B4D',
    display: 'inline-block',
    fontSize: '12px',
    fontWeight: 'bold',
    lineHeight: '1',
    minWidth: 1,
    padding: '0.16666666666667em 0.5em',
    textAlign: 'center',
}

const formatGroupLabel = data => (['Mis planes','Otros planes'].includes(data.label) &&
    <div className={groupBadgeStyles}>
        <span><img src={data.label === 'Mis planes' ? localizaN : localizaG }/>&nbsp;&nbsp;&nbsp;&nbsp;{data.label}</span>
    </div>
)

const formatOptionLabel = ({ label, poliza }) => (
    <div style={poliza ? { display: "flex", marginBottom: "-10px" } : { display: "flex" }}>
        <div>
            <p style={{fontFamily: "Arial", fontSize: "14px", color: "#183d7d", fontWeight:"bold"}}>{label}</p>
            { poliza &&
                <p style={{fontFamily: "Arial", fontSize: "12px", color: "#687a8d", marginTop: "-12px"}}>P&oacute;liza #{poliza}</p>
            }
        </div>
    </div>
)

let palanesClientesLength = 0;

class HospitalesForm extends React.Component {

    constructor() {
        super();
        localStorage.setItem("planValue", "0");
    }

    state = {
        planes: [],
        planesSubplanes: [],
        clase: ""
    }

    data = {
        contratacion:'general',
        estado:'0',
        municipio:'0',
        plan:'0'
    }

    componentWillReceiveProps(nextProps) {
		if(this.props.planeslp != nextProps.planeslp)
		{
			this.setState({ "planes" : nextProps.planeslp });
		}
	}

    componentWillMount = () => {

        if(!localStorage.getItem("planesCliente")) {
            localStorage.setItem("planesCliente", "");
        }

        let tmpPlanesCliente = localStorage.getItem("planesCliente");
        if (["", '', null, undefined].includes(tmpPlanesCliente)) {
            palanesClientesLength = 0;
        } else {
            palanesClientesLength = tmpPlanesCliente.split("|").length;
        }

        if(!localStorage.getItem("planesSubplanesGNP")) {
            try {
                $.ajax({
                    method: "GET",
                    url: urlBASE+"/directorios/planes-subplanes",
                    dataType: "json",
                    async: false,
                    success: (data) => {
                        localStorage.setItem("planesSubplanesGNP", JSON.stringify(data));
                    },
                    error: (error) => {
                        localStorage.setItem("planesSubplanesGNP", "");
                        console.log(error);
                    }
                });
            } catch (e) {
                console.log(e);
            }
        }


        if(this.props.estados.length == 0) {
            this.props.cargaEstados();
        }
        if(this.props.planes.length == 0){
            this.props.cargaPlanes();
            this.props.cargaPlanesSubplanes();
        }
        this.data = JSON.parse(JSON.stringify(this.props.initialValues));
        this.props.guardaItemSeleccionado();
        this.props.cambioFinalizo();
        this.props.cambiaFlagMarcadores(1);
        this.verificaContrato(this.data.contratacion);
    }

	selectFiltro = (_tipo, e) => {
        let valor = e.target.selectedOptions ? e.target.selectedOptions[0].value : e.target.defaultValue;
        this.data[_tipo] = valor;


        if(_tipo == "estado") {
            this.data.municipio = "0";
        }


        if(_tipo == "estado") {
            this.props.cargaMunicipios(valor);
            this.props.change("municipio", "0");
            if(this.data.contratacion == "general"){
				this.props.tagManager({ "type": "EVENT_DIRHOSP_INDIVIDUAL-ESTADO" });
			}
			else if(this.data.contratacion == "empresarial"){
				this.props.tagManager({ "type": "EVENT_DIRHOSP_COLECTIVO-ESTADO" });
			}
        }

        if(_tipo == "contratacion"){
            this.props.change("plan", "0");
            this.props.change("estado", "0");
            this.props.change("municipio", "0");
            this.data.contratacion = e.target.value;
            this.verificaContrato(e.target.value);
        }
        
        if(_tipo == "plan"){

            if(this.data.contratacion == "general"){
				this.props.tagManager({ "type": "EVENT_DIRHOSP_INDIVIDUAL-PLAN" });
			}
			else if(this.data.contratacion == "empresarial"){
				this.props.tagManager({ "type": "EVENT_DIRHOSP_COLECTIVO-PLAN" });
			}
        }
        
        if(_tipo == "municipio"){
            if(this.data.contratacion == "general"){
				this.props.tagManager({ "type": "EVENT_DIRHOSP_INDIVIDUAL-MUNICIPIO" });
			}
			else if(this.data.contratacion == "empresarial"){
				this.props.tagManager({ "type": "EVENT_DIRHOSP_COLECTIVO-MUNICIPIO" });
			}
        }
        this.props.guardarDatos(JSON.parse(JSON.stringify(this.data)));
    }

    verificaContrato(dato){
        this.setState({ "clase" :"" });
        if(dato == "empresarial"){
            this.setState({ "planes" : this.props.planeslc });
        }else{
            this.setState({ "planes" : this.props.planeslp });
        }
    }

    tratarPlanesClientes() {
        let planesCliente = localStorage.getItem("planesCliente");
	planesCliente = planesCliente.replace("|", "");
        let planesClienteArray = planesCliente.split("|");
        let resultado = "";
        let r;
        try{
	    for(let i = 0; i < planesClienteArray.length; i++) {
		resultado += planesClienteArray[i] + ",";
	    }
	    resultado = resultado.substr(0, resultado.length - 1);
            resultado = "{\"planesClientes\": [" + resultado + "]}";
            r = JSON.parse(resultado);
            r.planesClientes.map((res) => {
                res.cvePlan = this.transformarPlanes(res.cvePlan);
            });
            return r;
        } catch(e) {
            console.log(e);
            return JSON.parse("{}");
        }
    }

    transformarPlanes(idPlan) {
        let planVerdadero = idPlan;
        let planesSubplanesJSON = JSON.parse(localStorage.getItem("planesSubplanesGNP"));
        try {
            planesSubplanesJSON.map((psj) => {
                if(psj.idplan !== idPlan) {
                    let subplanes = psj.subplanes;
                    if(subplanes !== "") {
                        let subplanesArray = subplanes.split(",");
                        for(let i = 0; i < subplanesArray.length; i++) {
                            if(Number(subplanesArray[i]) === Number(idPlan)) {
                                planVerdadero = psj.idplan;
                                break;
                            }
                        }
                    }
                }
            });
        } catch(e) {
            console.log(e);
        }
        return planVerdadero;
    }

    generaOpciones(planes) {
        var str2 = "";
        var str = "";
        try{
            str = "[{\"label\": \"Mis planes\", \"options\": [";
            let misPlanes = this.tratarPlanesClientes();
            planes = JSON.parse(localStorage.getItem("planesSubplanesGNP"));
            misPlanes.planesClientes.map((plan) => {
                str2 = str2 + "{\"label\": \"" + plan.planComercial + "\", \"value\": \"" + plan.cvePlan + "\", \"poliza\": \"" + plan.numPoliza + "\"},";
            });
            str2 = str2.substring(0, str2.lastIndexOf(","));
            str = str + str2 + "]},";
            str = str + ((misPlanes.planesClientes.length) ? "{\"label\": \"Otros planes\", \"options\": [" : "{\"label\": \"\", \"options\": [");
            str2 = "{\"label\": \"Todos\", \"value\": \"0\", \"poliza\": \"\"},";
            planes.map((opt) => {
                str2 = str2 + "{\"label\": \"" + opt.nombre + "\", \"value\": \"" + opt.idplan + "\", \"poliza\":\"\"},";
            });
            str2 = str2.substring(0, str2.lastIndexOf(","));
            str = str + str2 + "]}]";
        } catch(e) {
            str = "{}";
        }
        return JSON.parse(str);
}

render () {
    	const { handleSubmit } = this.props;
        return (
			<form onSubmit={handleSubmit} style={{"marginTop":"40px"}}>
                <div className="input-wrap">
                    <label>Plan</label>
                    <span className="clearfix">
                        {palanesClientesLength > 0 && <Field name="plan" component={renderSelectR} options={this.generaOpciones(this.state.planesSubplanes)}
                               formatGroupLabel={formatGroupLabel} onChange={onChange}/>}

                        {palanesClientesLength == 0 && <Field name="plan" component={renderSelectField} onChange={onChange}>
                            {this.generaOpciones(this.state.planesSubplanes)[1]["options"].map((option, i) => {
                                return (<option value={option.value} key={i}>{option.label}</option>)
                            })}
                        </Field>}

                    </span>
                </div>
                <div className="input-wrap">
					<label>Estado</label>
					<span className="clearfix">
                        <Field name="estado" component={renderSelectField} onChange={this.selectFiltro.bind(this, "estado")}>
                            <option value="0">Todos</option>
                            { this.props.estados.map((option, i) =>
                                <option value={option.idestado} key={i}>{option.nombre}</option>
                            )}
                        </Field>
					</span>
				</div>

				<div className="input-wrap">
					<label>Delegación o Municipio</label>
					<span className="clearfix" style={{"color":"#183d7d !important"}}>
                        <Field id="dd" name="municipio" component={renderSelectField} onChange={this.selectFiltro.bind(this, "municipio")}>
                            <option value="0">Todos</option>
                            { this.props.municipios.map((option, i) =>
                                <option value={option.idmunicipio} key={i}>{option.nombre}</option>
                            )}
                        </Field>
					</span>
				</div>

				<button className='orange-btn' type="submit" style={{"margin":"10px auto","display":"inherit", "width":"200px", "height":"40px"}}>
				    Buscar
				</button>
			</form>
        )
    }
}

HospitalesForm = reduxForm({form: 'directorio-hospitales', validate})(HospitalesForm);
export default connect(mapState, mapDispatch)(HospitalesForm);



// WEBPACK FOOTER //
// ./src/directorio/hospitales.frm.js